import { isAutomatedWizard } from "../../../../app/components/appwizard/component-wizards/wizards/source/database-reader/app-services";
import APPTYPES from "../../apps/pages/create-app-page-templates/services/create-app-page-app-types.const.json";
import { DB_PROVIDERS } from "../../../../app/components/appwizard/component-wizards/wizards/source/database-reader/configs/db-providers";
import { getDatabaseType } from "../../../../app/components/appwizard/component-wizards/wizards/common/databaseTypes";
import componentService from "../../../../core/services/componentService/component-service";
import { createAppUtils } from "../../apps/pages/create-app-page-templates/create-app-page-utils";

export const isCDCAdapter = (adapter: string) => {
    switch (adapter) {
        case "OracleReader":
        case "MSSqlReader":
        case "MysqlReader":
        case "PostgreSQLReader":
        case "MariaDBReader":
        case "MariaDBXpandReader":
        case "MSJet":
        case "OJet":
        case "SalesforceCDCReader":
            return true;
        default:
            return false;
    }
};

export const isAppAdapter = (adapter: string) => {
    return DB_PROVIDERS[getDatabaseType(adapter)]?.isAppAdapter;
};

export const getWizardType = (sourceAdapter: string) => {
    const componentID = componentService.getComponentIDFromAdapterName(sourceAdapter);
    const isAppAdapterVal = createAppUtils.isSourceAppAdapter(componentID);
    if (isAutomatedWizard()) return APPTYPES.AUTOMATEDILCDC;
    if (isAppAdapterVal && sourceAdapter !== "SalesforceCDCReader") return APPTYPES.AUTOMATEDMODE;
    else return isCDCAdapter(sourceAdapter) ? APPTYPES.CDC : APPTYPES.IL;
};
